import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { selectors as userSelectors } from "../../../../redux/user";
import { addParameter } from "../../../utils/location";
import PageTitle from "../../../utils/page-title";
import { t } from "../../../core/translate";

const MainContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 88px 0 80px 0;
`;
const IframeContainer = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const InteractivesTab = ({ url }) => (
  <MainContainer>
    <PageTitle title={t("base.interactives", "Interactives")} />
    <IframeContainer src={url} width="100%" border="0" />
  </MainContainer>
);

const mapStateToProps = state => {
  const interactivesURL = brandSelectors.getBrandValue(
    state,
    "Interactives.url",
    "https://en.wikipedia.org/wiki/Interactivity"
  );
  const sessionId = userSelectors.getUser(state).sessionId;
  return {
    url: addParameter(interactivesURL, "sessionid", sessionId)
  };
};

export default connect(mapStateToProps)(InteractivesTab);
